module.exports = __webpack_public_path__ + "static/media/user-times.e0b18a97.svg";